/* eslint-disable react/jsx-indent */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Box,
  FormControlLabel,
  Grid,
  makeStyles,
  Switch,
  Tooltip,
  Typography,
} from '@material-ui/core';
import InputAdornmentChip from 'components/InputAdornmentChip';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import Alert from '@material-ui/lab/Alert';
import { Formik } from 'formik';
import i18n from 'i18n';
import { ClientFields } from 'modules/clients/interfaces';
import { isClientOperator } from 'utils/role';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Permission from 'components/ValidPermission';
import InputIcon from '@material-ui/icons/Input';
import { getAllEnvironmentsRequest } from 'modules/environments/actions';
import { getPartnerRequest } from 'modules/partners/actions';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import ApplicationState from 'store/interfaces';
import { applyI18n, superUser } from 'utils/helpers';
import {
  CompanyData,
  PartnerData,
  RolesEnum,
  PermissionsData,
} from 'modules/authenticate/interfaces';
import Button from 'components/Button';
import AutoSwitch from 'components/AutoSwitch';

import { PartnerFormFields } from 'modules/partners/interfaces';
import palette from 'theme/palette';
import screenFields from './FormFields';
import { init, ssoInitialFields } from './initialValues';
import schema from './schema';
import styles from './styles';
import ClientSwitchOptions from './ClientSwitchOptions';
import MFAButton from './MFAButton';
import ClientSSOConfig from './ClientSSOConfig';
import SelectEnvironment from './SelectEnvironment';
import ClientDUOConfig from './ClientDUOConfig';

const useStyles = makeStyles(styles);

export interface Query {
  offset: number;
  limit: number;
  search: string;
}

const query: Query = {
  offset: 0,
  limit: 150,
  search: '',
};

const dictionaryDefaultPrimaryPortValues = {
  tsplus_all: 50491,
  tsplus: 50491,
  connect: 491,
  connect_direct: 491,
  tsplus_remote_app: 50491,
};

const dictionaryDefaultSecondPortValues = {
  tsplus_all: 443,
  tsplus: 443,
};

interface Props {
  isLoading: boolean;
  companySelected: CompanyData | null;
  partnerDetails: PartnerFormFields | null;
  partnerSelected: PartnerData | null;
  permissions: PermissionsData | undefined;
  isEdit?: boolean;
  initialValues?: ClientFields | null;
  role?: RolesEnum;
  messagesRequest: (props) => void;
  getAllEnvironmentsRequest: (props) => void;
  getPartnerRequest: (id: string) => void;
  onSubmit: (values: any) => void;
}

const setVirtualizerValues = (key: string, value, setFieldValue): void => {
  if (key === 'user_connection.virtualizer') {
    setFieldValue(key, value);
    return;
  }
  setFieldValue(key, value || null);
};

const setDefaultPortValues = (values, value, setFieldValue) => {
  const primaryPortKey = 'user_connection.connect_port';
  const secondPortKey = 'user_connection.service_port';
  const defaultPortValues = {
    [primaryPortKey]: dictionaryDefaultPrimaryPortValues[value],
    [secondPortKey]: dictionaryDefaultSecondPortValues[value],
  };

  if (
    !values.user_connection.connect_port &&
    defaultPortValues[primaryPortKey]
  ) {
    setFieldValue(primaryPortKey, defaultPortValues[primaryPortKey] || false);
  }
  if (
    !values.user_connection.service_port &&
    defaultPortValues[secondPortKey]
  ) {
    setFieldValue(secondPortKey, defaultPortValues[secondPortKey] || false);
  }
};

const AddClient = ({
  isLoading,
  companySelected,
  partnerDetails,
  partnerSelected,
  permissions,
  isEdit,
  initialValues,
  role,
  getAllEnvironmentsRequest,
  getPartnerRequest,
  onSubmit,
}: Props) => {
  const classes = useStyles();
  const history = useHistory();

  const inSuperUserView = !companySelected && superUser(role);
  const redirectToPath = inSuperUserView ? '/all-clients' : '/clients';
  const [collapseObservations, setCollapseObservations] = React.useState<
    boolean
  >(false);

  React.useEffect(() => {
    if (partnerSelected) {
      if (!isEdit && permissions?.list_partner_details) {
        getPartnerRequest(partnerSelected.id);
      }
    }
  }, [getAllEnvironmentsRequest, getPartnerRequest, partnerSelected]);

  const [virtualizer, setVirtualizer] = React.useState({
    virtualizer: [null, ''].includes(
      initialValues?.user_connection?.virtualizer || null
    ),
  });
  const [duoStatus, setDuoStatus] = React.useState(initialValues?.duo?.enabled);
  const allowConnectionType =
    initialValues?.user_connection?.connection_type
      ?.environment_allow_configuration;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVirtualizer({
      ...virtualizer,
      [event.target.name]: event.target.checked,
    });
  };

  const generalFormInitial = React.useMemo(() => {
    if (initialValues) {
      return {
        ...initialValues,
        environment_uuid: initialValues?.environment?.environment_uuid,
      } as ClientFields;
    }

    return {
      ...init,
      partner: {
        new_front: permissions?.list_partner_details
          ? partnerDetails?.frontend?.enable_new_interface
          : null,
      },
    };
  }, [initialValues, partnerDetails]);

  const formInitialValues = React.useMemo(() => {
    if (!initialValues?.sso) {
      return {
        ...generalFormInitial,
        sso: ssoInitialFields,
      };
    }

    return generalFormInitial;
  }, [generalFormInitial, initialValues]);

  const handleSubmit = values => {
    const submitVirtualBox = values;

    if (virtualizer.virtualizer === true) {
      submitVirtualBox.user_connection = {
        ...values?.user_connection,
        virtualizer: '',
        connect_port: null,
        service_port: null,
      };
    }

    if (!(values as ClientFields)?.sso_enabled) {
      delete (submitVirtualBox as ClientFields)?.sso;
    }
    if (values?.duo?.enabled === false) {
      const { duo } = submitVirtualBox as ClientFields;

      if (duo) {
        delete duo.host;
        delete duo.duo_client_secret;
        delete duo.duo_client_id;
        delete duo.bypass_if_unavailable;
      }
    }

    if (!isEdit && values?.duo?.enabled === false) {
      delete (submitVirtualBox as ClientFields)?.duo;
    }

    if (submitVirtualBox?.user_access_without_ad) {
      delete submitVirtualBox.user_access_without_ad.environment_enabled;
    }

    onSubmit(submitVirtualBox);
  };

  const filteredVirtualizerFields = (values): GenericFormItem[] =>
    applyI18n(
      screenFields.virtualizer.slice(
        0,
        ['tsplus', 'tsplus_all'].includes(values?.user_connection?.virtualizer)
          ? 3
          : 2
      ),
      i18n.language
    );

  const shouldValidateLicenseLimit =
    initialValues?.partner?.enforce_env_license_limit &&
    initialValues?.environment?.licenses?.control_licenses_by_client;

  return partnerSelected ||
    permissions?.can_view_all_resources ||
    inSuperUserView ? (
    <Formik
      validationSchema={schema(
        initialValues?.licenses?.available_licenses_to_client,
        virtualizer?.virtualizer,
        initialValues?.user_connection?.virtualizer,
        duoStatus,
        shouldValidateLicenseLimit
      )}
      initialValues={formInitialValues}
      onSubmit={handleSubmit}
      validateOnBlur
      validateOnChange
    >
      {({ setFieldValue, submitForm, errors, values }) => (
        <Grid className={classes.container} spacing={2} container>
          <GenericForm
            overrideClasses={{
              selectLabel: { fontSize: 12, fontWeight: 500 },
            }}
            fields={values}
            screenFields={applyI18n([screenFields.first[0]], i18n.language)}
            setFieldValue={setFieldValue}
            errors={errors}
          />
          <div className={classes.tooltipContainer}>
            <Tooltip placement="top" arrow title={i18n.t('EXTERNAL_INFO_KEY')}>
              <div className={classes.tooltipContent}>
                <InfoIcon fontSize="small" color="action" />
              </div>
            </Tooltip>
          </div>
          <GenericForm
            overrideClasses={{
              selectLabel: { fontSize: 12, fontWeight: 500 },
            }}
            fields={values}
            screenFields={applyI18n([screenFields.first[1]], i18n.language)}
            setFieldValue={setFieldValue}
            errors={errors}
          />
          <InputAdornmentChip
            styles={{
              padding: '8px 7px',
            }}
            gridXs={7}
            label={i18n.t('ADMIN_EMAIL_KEY')}
            stateKey="email_admin"
            values={values?.email_admin?.split(',').filter(Boolean) || []}
            setFieldValue={setFieldValue}
          />
          <Grid item xs={6}>
            <SelectEnvironment
              errors={errors}
              initialEnvironment={initialValues?.environment}
              stateKey="environment_uuid"
              setFieldValue={setFieldValue}
              isEdit={isEdit}
            />
          </Grid>
          {isEdit && (
            <GenericForm
              overrideClasses={{
                selectLabel: { fontSize: 12, fontWeight: 500 },
              }}
              fields={values}
              screenFields={applyI18n([screenFields.first[2]], i18n.language)}
              setFieldValue={setFieldValue}
              errors={errors}
            />
          )}
          <Grid item xs={12}>
            <ClientSwitchOptions
              setFieldValue={setFieldValue}
              values={values}
            />
          </Grid>
          {values?.active_directory?.remote_profile && (
            <Grid item xs={12} className={classes.profilePathField}>
              <GenericForm
                overrideClasses={{
                  selectLabel: { fontSize: 12, fontWeight: 500 },
                }}
                fields={values}
                screenFields={applyI18n([screenFields.first[3]], i18n.language)}
                setFieldValue={setFieldValue}
                errors={errors}
              />
            </Grid>
          )}
          {Boolean((values as ClientFields)?.client_uuid?.length) && (
            <Grid item xs={12}>
              <MFAButton client={values} query={query} />
            </Grid>
          )}
          {isEdit &&
            initialValues?.environment?.licenses.control_licenses_by_client && (
              <>
                <Grid container>
                  <Typography className={classes.sectionTitle} variant="h4">
                    {i18n.t('LICENSES_KEY')}
                  </Typography>
                  <Grid item xs={12} style={{ marginLeft: 8 }}>
                    {initialValues?.licenses.client_license && (
                      <Grid container className={classes.formLicenseSwitch}>
                        <FormControlLabel
                          className={classes.formLabel}
                          control={
                            <Switch
                              size="small"
                              onChange={(e, value) =>
                                setFieldValue(
                                  'licenses.client_license.has_license_limit',
                                  !!value
                                )
                              }
                              checked={
                                !!values?.licenses?.client_license
                                  ?.has_license_limit
                              }
                            />
                          }
                          label={
                            <Typography className={classes.switchText}>
                              {i18n.t('LICENSE_LIMIT_KEY')}
                            </Typography>
                          }
                        />
                      </Grid>
                    )}
                    {values?.licenses?.client_license?.has_license_limit && (
                      <Grid container spacing={2}>
                        <GenericForm
                          overrideClasses={{
                            selectLabel: { fontSize: 12, fontWeight: 500 },
                          }}
                          fields={values}
                          screenFields={applyI18n(
                            [screenFields.licenses[0]],
                            i18n.language
                          )}
                          setFieldValue={setFieldValue}
                          errors={errors}
                        />
                        {initialValues?.partner?.enforce_env_license_limit && (
                          <GenericForm
                            overrideClasses={{
                              selectLabel: { fontSize: 12, fontWeight: 500 },
                            }}
                            fields={values}
                            screenFields={applyI18n(
                              [screenFields.licenses[1]],
                              i18n.language
                            )}
                            setFieldValue={setFieldValue}
                            errors={errors}
                          />
                        )}
                      </Grid>
                    )}
                    {initialValues?.licenses?.license_group && (
                      <Grid container>
                        <Grid item xs={12}>
                          <Typography className={classes.text} component="div">
                            {`${i18n.t('THIS_CLIENT_IS_IN_GROUP_KEY')}: `}
                            <Box
                              color={palette.blue}
                              fontWeight="bold"
                              display="inline"
                              className={classes.boxInfo}
                            >
                              {initialValues?.licenses?.license_group?.name}
                            </Box>
                            <Tooltip
                              title={i18n.t('CLIENT_IN_GROUP_TOOLTIP_KEY')}
                            >
                              <InfoIcon className={classes.infoIcon} />
                            </Tooltip>
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography className={classes.text} component="div">
                            {`${i18n.t('LICENSE_LIMIT_GROUP_KEY')}: `}
                            <Box
                              color={palette.blue}
                              fontWeight="bold"
                              display="inline"
                              className={classes.boxInfo}
                            >
                              {
                                initialValues?.licenses?.license_group
                                  ?.license_limit
                              }
                            </Box>
                          </Typography>
                        </Grid>
                        <Permission value="list_license_groups">
                          <Grid item>
                            <Button
                              outlineBlue
                              startIcon={<InputIcon />}
                              className={classes.accessButton}
                              onClick={e => {
                                e.stopPropagation();
                                history.push(
                                  `/environments/${initialValues?.environment?.environment_uuid}/configuration/licenseGroup/${initialValues?.licenses?.license_group.uuid}`
                                );
                              }}
                            >
                              {i18n.t('ACCESS_GROUP_KEY')}
                            </Button>
                          </Grid>
                        </Permission>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </>
            )}
          <Grid container>
            <Typography className={classes.sectionTitle} variant="h4">
              {i18n.t('INTERFACE_KEY')}
            </Typography>
          </Grid>
          <Grid container className={classes.switchContainer}>
            <FormControlLabel
              className={classes.formLabel}
              control={
                <Switch
                  id="toggle-use-partner-new-front"
                  size="small"
                  onChange={(_, value) =>
                    setFieldValue(
                      'new_front',
                      value
                        ? null
                        : (values as ClientFields)?.partner?.new_front ?? true
                    )
                  }
                  checked={values?.new_front === null}
                  name="partner_new_front"
                />
              }
              label={
                <Typography className={classes.switchText}>
                  {i18n.t('USE_PARTNER_NEW_FRONT_KEY')}
                </Typography>
              }
            />
          </Grid>
          {values?.new_front === null ? (
            <GenericForm
              overrideClasses={{
                selectLabel: { fontSize: 12, fontWeight: 500 },
              }}
              fields={values}
              screenFields={[
                {
                  gridXs: 6,
                  stateKey:
                    permissions?.can_view_all_resources && !isEdit
                      ? 'new_front'
                      : 'partner.new_front',
                  label: i18n.t('SET_INTERFACE_KEY'),
                  isSelect: true,
                  options: [
                    { value: 'true', label: i18n.t('USE_NEW_FRONT_KEY') },
                    { value: 'false', label: i18n.t('USE_OLD_FRONT_KEY') },
                  ],
                  disabled: true,
                },
              ]}
              setFieldValue={(key, value) => setFieldValue('new_front', value)}
              errors={errors}
            />
          ) : (
            <GenericForm
              overrideClasses={{
                selectLabel: { fontSize: 12, fontWeight: 500 },
              }}
              fields={values}
              screenFields={[
                {
                  gridXs: 6,
                  stateKey: 'new_front',
                  label: i18n.t('SET_INTERFACE_KEY'),
                  isSelect: true,
                  options: [
                    { value: 'true', label: i18n.t('USE_NEW_FRONT_KEY') },
                    { value: 'false', label: i18n.t('USE_OLD_FRONT_KEY') },
                  ],
                },
              ]}
              setFieldValue={(key, value) => setFieldValue('new_front', value)}
              errors={errors}
            />
          )}
          <Grid container>
            <Typography className={classes.sectionTitle} variant="h4">
              {i18n.t('VIRTUALIZER_KEY')}
            </Typography>
          </Grid>
          <Grid container className={classes.switchContainer}>
            <FormControlLabel
              className={classes.formLabel}
              control={
                <Switch
                  id="toggle-use-environment-virtualizer"
                  size="small"
                  onChange={handleChange}
                  checked={virtualizer?.virtualizer}
                  name="virtualizer"
                />
              }
              label={
                <Typography className={classes.switchText}>
                  {i18n.t('USE_ENVIRONMENT_VIRTUALIZER_KEY')}
                </Typography>
              }
            />
          </Grid>
          {virtualizer.virtualizer === false && (
            <GenericForm
              overrideClasses={{
                selectLabel: { fontSize: 12, fontWeight: 500 },
              }}
              fields={values}
              screenFields={filteredVirtualizerFields(values)}
              setFieldValue={(key, value) => {
                setVirtualizerValues(key, value, setFieldValue);
              }}
              changeField={({ key, value }) => {
                setDefaultPortValues(values, value, setFieldValue);
                setFieldValue(key, value);
              }}
              errors={errors}
            />
          )}
          {isEdit && !isClientOperator(role) && (
            <>
              <Grid container>
                <Typography className={classes.sectionTitle} variant="h4">
                  {i18n.t('CONNECTION_TYPE_KEY')}
                </Typography>
              </Grid>
              <AutoSwitch
                label={
                  <Typography className={classes.switchText}>
                    {i18n.t('USE_ENVIRONMENT_CONNECTION_TYPE_KEY')}
                  </Typography>
                }
                id="toggle-use-environment-connection-type"
                size="small"
                onChange={(_, value) =>
                  setFieldValue(
                    'user_connection.connection_type.enabled',
                    !value
                  )
                }
                checked={
                  !allowConnectionType ||
                  !(values as ClientFields)?.user_connection?.connection_type
                    ?.enabled
                }
                disabled={!allowConnectionType}
                hover={i18n.t(
                  'ENVIRONMENT_CONNECTION_TYPE_DISABLED_EXPLANATION_KEY'
                )}
              />
              {allowConnectionType &&
                (values as ClientFields)?.user_connection?.connection_type
                  ?.enabled && (
                  <GenericForm
                    overrideClasses={{
                      selectLabel: { fontSize: 12, fontWeight: 500 },
                    }}
                    fields={values}
                    screenFields={applyI18n(
                      screenFields?.connectionType,
                      i18n.language
                    )}
                    setFieldValue={setFieldValue}
                    errors={errors}
                  />
                )}
            </>
          )}
          {isEdit &&
            (values as ClientFields)?.partner?.allow_sso_configuration &&
            role !== RolesEnum.clientOperator && (
              <ClientSSOConfig
                setFieldValue={setFieldValue}
                clientSelected={values as ClientFields}
                errors={errors}
              />
            )}
          {((values as ClientFields)?.partner?.allow_duo_configuration ||
            partnerDetails?.allow_duo_configuration) && (
            <ClientDUOConfig
              setFieldValue={setFieldValue}
              clientSelected={values as ClientFields}
              errors={errors}
              setDuoStatus={setDuoStatus}
            />
          )}
          {!isClientOperator(role) && (
            <>
              <Grid container>
                <Typography className={classes.sectionTitle} variant="h4">
                  {i18n.t('NO_AD_AUTH_TITLE')}
                </Typography>
              </Grid>

              <Grid container className={classes.switchContainer}>
                <FormControlLabel
                  className={classes.formLabel}
                  control={
                    <Switch
                      id="toggle-no-ad-auth"
                      size="small"
                      checked={values?.user_access_without_ad?.enabled === null}
                      onChange={(_, checked) => {
                        setFieldValue(
                          'user_access_without_ad.enabled',
                          checked
                            ? null
                            : values?.user_access_without_ad?.enabled ??
                                values?.user_access_without_ad
                                  ?.environment_enabled ??
                                false
                        );
                      }}
                      name="no_ad_override"
                    />
                  }
                  label={
                    <Typography className={classes.switchText}>
                      {i18n.t('USE_ENVIRONMENT_SETTING_KEY')}
                    </Typography>
                  }
                />
              </Grid>

              {values?.user_access_without_ad?.enabled === null ? (
                <GenericForm
                  overrideClasses={{
                    selectLabel: { fontSize: 12, fontWeight: 500 },
                  }}
                  fields={values}
                  screenFields={[
                    {
                      gridXs: 6,
                      stateKey: 'user_access_without_ad.environment_enabled',
                      label: i18n.t('AD_AUTH_CONFIG_KEY'),
                      isSelect: true,
                      options: [
                        { value: 'true', label: i18n.t('AUTH_WITHOUT_AD_KEY') },
                        { value: 'false', label: i18n.t('AUTH_WITH_AD_KEY') },
                      ],
                      disabled: true,
                    },
                  ]}
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  setFieldValue={() => {}}
                  errors={errors}
                />
              ) : (
                <GenericForm
                  overrideClasses={{
                    selectLabel: { fontSize: 12, fontWeight: 500 },
                  }}
                  fields={values}
                  screenFields={[
                    {
                      gridXs: 6,
                      stateKey: 'user_access_without_ad.enabled',
                      label: i18n.t('AD_AUTH_CONFIG_KEY'),
                      isSelect: true,
                      options: [
                        { value: 'true', label: i18n.t('AUTH_WITHOUT_AD_KEY') },
                        { value: 'false', label: i18n.t('AUTH_WITH_AD_KEY') },
                      ],
                    },
                  ]}
                  setFieldValue={(key, value) =>
                    setFieldValue('user_access_without_ad.enabled', value)
                  }
                  errors={errors}
                />
              )}
            </>
          )}

          <Grid container alignItems="center">
            <Typography
              className={classes.sectionTitleObs}
              variant="h4"
              component="div"
              onClick={() => setCollapseObservations(!collapseObservations)}
            >
              {i18n.t('OBSERVATIONS_KEY')}
              <Box fontWeight="bold" display="inline">
                {collapseObservations ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Box>
            </Typography>
          </Grid>
          {collapseObservations && (
            <Grid container className={classes.observationsGrid}>
              <GenericForm
                fields={values}
                screenFields={[
                  {
                    gridXs: 12,
                    stateKey: 'observations',
                    label: i18n.t('OBSERVATIONS_KEY'),
                    isMultiline: true,
                  },
                ]}
                setFieldValue={(key, value) =>
                  setFieldValue('observations', value)
                }
                errors={errors}
              />
            </Grid>
          )}

          <Grid container justify="flex-end" className={classes.buttons}>
            <Button
              id="submit-button"
              onClick={submitForm}
              submitButton
              disabled={isLoading}
            >
              {i18n.t(isEdit ? 'SAVE_KEY' : 'ADD_KEY')}
            </Button>
            <Button
              id="cancel-button"
              variant="outlined"
              onClick={() => history.push(redirectToPath)}
            >
              {i18n.t('CANCEL_KEY')}
            </Button>
          </Grid>
        </Grid>
      )}
    </Formik>
  ) : (
    <Alert className={classes.alert} severity="warning" color="info">
      <span>{i18n.t('CREATE_CLIENT_COMPANY_AND_PARTNER_KEY')}</span>
    </Alert>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected, partnerSelected, data },
  clients: { isLoading },
  partners: { partnerDetails },
}: ApplicationState) => ({
  isLoading,
  companySelected,
  partnerDetails,
  partnerSelected,
  permissions: data?.permissions,
  role: data?.role,
});

export default connect(mapStateToProps, {
  getAllEnvironmentsRequest,
  getPartnerRequest,
})(AddClient);
